//GeneratorFlag:[NoChange]
import NoticePattern from './notice-pattern';
import NoticeType from './notice-type';

export default {NoticePattern, NoticeType}
export{NoticePattern, NoticeType}